"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryStorage = exports.Storage = void 0;
const encoding_1 = require("./encoding");
const error_1 = require("./error");
class Storage {
    constructor(marshaler = new encoding_1.JSONMarshaler()) {
        this.marshaler = marshaler;
    }
    async set(key, obj) {
        // @ts-ignore
        return this._set(`${obj.constructor.name}_${key}`, this.marshaler.marshal((0, encoding_1.serialize)(obj)));
    }
    async get(cl, key) {
        return (0, encoding_1.deserialize)(cl, this.marshaler.unmarshal(await this._get(`${cl.name}_${key}`)));
    }
    async delete(cl, key) {
        return this._delete(`${cl.name}_${key}`);
    }
}
exports.Storage = Storage;
class MemoryStorage extends Storage {
    constructor() {
        super(...arguments);
        this._storage = new Map();
    }
    async _set(key, obj) {
        this._storage.set(key, obj);
    }
    async _get(key) {
        if (!this._storage.has(key)) {
            throw new error_1.Err(error_1.ErrorCode.NOT_FOUND);
        }
        return this._storage.get(key);
    }
    async _delete(key) {
        this._storage.delete(key);
    }
    async clear() {
        this._storage = new Map();
    }
}
exports.MemoryStorage = MemoryStorage;
//# sourceMappingURL=storage.js.map